// Bulk upload only: media.register happens for every selected file immediately
// (so all N media docs/tabs exist right away), but the actual chunk upload
// (r.upload()) is gated to run at most VITE_BULK_UPLOAD_CONCURRENCY files at a
// time. This is a single module-level FIFO queue shared across every
// BulkUploadForm submission, so a second 5-file batch started while the first
// is still uploading queues behind it instead of running alongside it.
const BULK_UPLOAD_CONCURRENCY =
  Number(import.meta.env.VITE_BULK_UPLOAD_CONCURRENCY) || 2;

const queue: Array<() => void> = [];
let activeCount = 0;

const runNext = () => {
  if (activeCount >= BULK_UPLOAD_CONCURRENCY) return;
  const next = queue.shift();
  if (!next) return;
  activeCount += 1;
  next();
};

// Call `start()` when the file's chunk upload actually begins, and `release()`
// exactly once when it settles (success or error) to free its queue slot.
export const enqueueBulkUpload = (
  start: () => void
): { release: () => void } => {
  queue.push(start);
  runNext();

  let released = false;
  const release = () => {
    if (released) return;
    released = true;
    activeCount -= 1;
    runNext();
  };

  return { release };
};
